import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取账单汇率列表
export function getBillingRateList(params) {
  return request({
    url: URL.mdm.rate.billingRateInfo,
    method: 'get',
    params
  })
}
// 新增账单汇率
export function addBillingRate(data) {
  return request({
    url: URL.mdm.rate.billingRateInfo,
    method: 'post',
    data
  })
}
// 编辑账单汇率
export function updateBillingRate(data) {
  return request({
    url: URL.mdm.rate.billingRateInfo,
    method: 'put',
    data
  })
}
// 复制账单汇率
export function copyBillingRate(data) {
  return request({
    url: URL.mdm.rate.copyBillingRateInfo,
    method: 'put',
    data
  })
}
// 确认复制账单汇率
export function confirmCopyBillingRate(data) {
  return request({
    url: URL.mdm.rate.confirmCopyBillingRateInfo,
    method: 'put',
    data
  })
}
// 删除账单汇率
export function batchDelBillingRate(data) {
  return request({
    url: URL.mdm.rate.billingRateInfo,
    method: 'delete',
    data
  })
}
// 根据原币种，目标币种，汇率日期查询账单汇率
export function queryBillingRateListByCurrencyAndDate(requestBody) {
  return request({
    url: URL.mdm.rate.getBillingRateListByCurrencyAndDate,
    method: 'post',
    data: requestBody
  })
}
